import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  MdCallEnd,
  MdOutlineScreenShare,
  MdOutlineStopScreenShare,
  MdContentCopy,
  MdCheck,
  MdShare,
} from "react-icons/md";
import {
  FaMicrophone,
  FaMicrophoneSlash,
  FaVideo,
  FaVideoSlash,
  FaUsers,
} from "react-icons/fa6";
import { LuSlash } from "react-icons/lu";
import { BsChatLeftDotsFill } from "react-icons/bs";
import { AuthContext } from "../../contexts/AuthContext";
import { leaveMeeting } from "../../services/mediasoup-client";
import {
  toggleVideo,
  toggleAudio,
} from "../../services/web-RTC";
import { useMediasoupClient } from "../../hooks/useMediasoupClient";
import { useMeeting } from "../../hooks/useMeeting";
import { socket } from "../../services/socket";
import {
  groupConsumersByUser,
  consumeRemoteStreamVideo,
} from "../../services/mediasoup-client";

export default function FooterMeetVideo({
  display,
  setNewMessage,
  toggleRaiseHand,
  raisedHands,
  setDisplay,
  accessCode,
  mediasTools,
  newMessage,
}) {
  const { constraints, isMuted, setIsMuted, setShowCodeOrLink } = mediasTools;
  const location = useNavigate();
  const {
    setLocalStream,
    localStream,
    screenStream,
    setMyPeer,
    myPeer,
    participants,
    setParticipants,
    endMeetingSession,
  } = useMeeting();
  const {
    isScreenSharing,
    setIsScreenSharing,
    setScreenStream,
    setSendTransport,
    setRecvTransport,
    producerAudio,
    setProducerAudio,
    producerVideo,
    setProducerVideo,
    sendTransport,
    recvTransport,
  } = useMediasoupClient();
  const { user } = useContext(AuthContext);
  const [displayCopy, setDisplayCopy] = useState(false);
  const [screenShare, setScreenShare] = useState(false);
  const [mainlevee, setMainLevee] = useState(false);
  const [displayVideo, setDisplayVideo] = useState(constraints.video);
  const handRef = useRef(null);

  useEffect(() => {
    setTimeout(() => setDisplayCopy(false), 3000);
  }, [displayCopy]);

  useEffect(() => {
    socket.on("old_participant_produce_video", async (consumers) => {
      for (const consumer of groupConsumersByUser(consumers)) {
        await consumeRemoteStreamVideo(
          consumer,
          recvTransport,
          setParticipants,
          participants
        );
      }
    });

    return () => {
      socket.off("old_participant_produce_video");
    };
  }, [participants, socket]);

  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setDisplayCopy(true);
      })
      .catch((err) => {
        console.error("Erreur de copie :", err);
      });
  };

  const handleClick = () => {
    if (!mainlevee) {
      const el = handRef.current;
      el.classList.remove("clicked");
      void el.offsetWidth; // force reflow
      el.classList.add("clicked");

      // Retirer la classe une fois l'animation terminée
      const removeClass = () => {
        el.classList.remove("clicked");
        el.removeEventListener("animationend", removeClass);
      };
      el.addEventListener("animationend", removeClass);
    }
  };

  const toggleDemanderLaParole = () => {
    toggleRaiseHand();
    handleClick();
    setMainLevee(!mainlevee);
  };

  return (
    <>
      <div style={{
        ...fixedBottom,
        backgroundColor: "transparent",
        padding: "8px 16px",
      }}>
        <div className="mon-composant-meet-video-footer-content d-flex justify-content-between">
          <h2
            style={{
              color: "#fff",
              backgroundColor: "#023377",
              padding: "10px",
            }}
          >
            {displayCopy ? (
              <MdCheck
                style={{
                  position: "absolute",
                  color: "#00b074",
                  left: "8px",
                  zIndex: 2,
                  fontSize: "25px",
                }}
              />
            ) : (
              <MdContentCopy
                onClick={() => handleCopy(accessCode)}
                style={{
                  left: 5,
                  top: 7,
                  position: "absolute",
                  fontSize: "30px",
                  cursor: "pointer",
                }}
              />
            )}

            {accessCode}
          </h2>
          <div className="mon-composant-meet-video-middle-icons">
            <span
              onClick={() =>
                toggleAudio({
                  isMuted,
                  setIsMuted,
                  producerAudio,
                  participants,
                  setParticipants,
                  user,
                })
              }
            >
              {isMuted ? (
                <FaMicrophoneSlash className="mon-icone-meet-video" />
              ) : (
                <FaMicrophone className="mon-icone-meet-video" />
              )}
            </span>
            <span
              onClick={() => {
                toggleVideo(
                  {
                    producerVideo,
                    participants,
                    setParticipants,
                    displayVideo,
                    setDisplayVideo,
                    user,
                  },
                  {
                    sendTransport,
                    setProducerVideo,
                    localStream,
                    setMyPeer,
                    myPeer,
                    setLocalStream,
                    isMuted,
                  }
                );
              }}
            >
              {displayVideo ? (
                <FaVideo className="mon-icone-meet-video" />
              ) : (
                <FaVideoSlash className="mon-icone-meet-video" />
              )}
            </span>
            <span
              onClick={() => {
                alert("fonctionnalité en cours de developpement");
              }}
            >
              {isScreenSharing ? (
                <MdOutlineStopScreenShare className="mon-icone-meet-video" />
              ) : (
                <MdOutlineScreenShare className="mon-icone-meet-video" />
              )}
            </span>
            <span
              onClick={() => {
                toggleDemanderLaParole();
              }}
              className="hand"
              ref={handRef}
            >
              {raisedHands.find((p) => p.userId === user.userId) ? (
                <>
                  <LuSlash
                    style={{
                      color: "red",
                      fontSize: "30px",
                      position: "absolute",
                      left: "10%",
                      top: "10%",
                    }}
                  />
                  <div>🖐🏾</div>
                </>
              ) : (
                <div>🖐🏾</div>
              )}
            </span>
            {/* Partage d'ecran masque pour le moment */}
            <span
              onClick={() => {
                if (mainlevee) {
                  toggleDemanderLaParole();
                }
                leaveMeeting({
                  userId: user.userId,
                  location,
                  endMeetingSession,
                  setSendTransport,
                  setRecvTransport,
                  setProducerAudio,
                  setProducerVideo,
                  setIsScreenSharing,
                  setScreenStream,
                  sendTransport,
                  recvTransport,
                  producerVideo,
                  producerAudio,
                  localStream,
                  screenStream,
                });
              }}
            >
              <MdCallEnd className="mon-icone-meet-video" />
            </span>
          </div>
          <div className="mon-composant-meet-video-end-icons">
            <span style={styleSpan}>
              <FaUsers
                style={{ color: "#fff" }}
                className="mon-icone-meet-video"
              />
              {participants.length > 1 && (
                <div
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    minWidth: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    color: "#fff",
                    background: "red",
                    fontSize: "0.7rem",
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0 4px",
                  }}
                >
                  {participants.length}
                </div>
              )}
            </span>
            <span
              className={`${
                newMessage
                  ? "animate__animated animate__pulse animate__infinite"
                  : ""
              } offcanvas-toggle-button`}
              style={styleSpan}
              onClick={(evt) => {
                evt.stopPropagation();
                setNewMessage(false);
                setDisplay(!display);
              }}
            >
              {newMessage && !display && (
                <div
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    minWidth: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    color: "#fff",
                    background: "red",
                    fontSize: "0.7rem",
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0 4px",
                  }}
                >
                  *
                </div>
              )}
              <BsChatLeftDotsFill
                style={{ color: "#fff" }}
                className="mon-icone-meet-video"
              />
            </span>
            <span style={styleSpan} onClick={() => setShowCodeOrLink(true)}>
              <MdShare
                style={{ color: "#fff" }}
                className="mon-icone-meet-video"
              />
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

const styleSpan = {
  backgroundColor: "#023377",
  borderRadius: "50%",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
};
const fixedBottom = {
  zIndex: "19 !important",
  position: "fixed",
  right: 0,
  bottom: 0,
  left: 0,
};
